import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.LegacyList.IRequest;
type Response = Api.Core.Claim.LegacyList.IResponse;
type Headers = Api.Core.Claim.LegacyList.IHeaders;
const url = '/api/Claims/Claim/GetLegacyClaims/:appNumber';
export default async function claimLegacyListApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
